import { Button, Icon, Toast, type ToastType } from "@legal-500/legal500-design-system";
import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PageHeader } from "../../../components/PageHeader";
import { ROUTES } from "../../../routes";
import styles from "../UserManagement.module.css";

function OrganisationsLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [toast, setToast] = useState<{ message: string; type: ToastType } | null>(null);
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  function handleMutationSuccess() {
    setRefetchTrigger(prev => prev + 1);
  }

  function handleBackClick() {
    if (window.history.length > 1 && location.key !== "default") {
      navigate(-1);
    } else {
      navigate(ROUTES.users.organisations);
    }
  }

  function handleCloseToast() {
    setToast(null);
  }

  const isDetailPage = location.pathname !== ROUTES.users.organisations;

  return (
    <div className={styles.wrapper}>
      <div>
        <PageHeader title="Organisations" subtitle="Manage customer organisations and memberships">
          {isDetailPage ? (
            <Button variant="outlined" color="default" onClick={handleBackClick}>
              <Icon icon="arrow-left" size="small" />
              Back
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(ROUTES.users.organisationNew)}
            >
              Create organisation
            </Button>
          )}
        </PageHeader>
      </div>

      <Outlet
        context={{
          toast,
          setToast,
          refetchTrigger,
          onMutationSuccess: handleMutationSuccess,
        }}
      />

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={handleCloseToast}
          duration={5000}
        />
      )}
    </div>
  );
}

export default OrganisationsLayout;
